/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * All locale sensitive properties reference the text in resource modules. There are separate resource modules for different languages. The resource modules are loaded dynamically based on the current run locale. To ensure that, the implementation of 'import' has to be able to resolve macros containing session parameters.  There are separate textResource elements for different contexts. <p>Java class for textResource complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="textResource"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="resourceLanguage" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="context" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="item" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="text" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class TextResource extends MoserObject{

	resourceLanguage = null;

	context = null;

	item = null;



	/**
	 * Gets the value of the resourceLanguage property.
	 * @return {String} possible object is {@link String}
	 */
	getResourceLanguage() {
		return this.resourceLanguage;
	}

	/**
	 * Sets the value of the resourceLanguage property.
	 * @param {String} value allowed object is {@link String}
	 */
	setResourceLanguage(value) {
		var oldValue = this.resourceLanguage;
		this.resourceLanguage = value;
		this._setAndNotify(89, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the context property.
	 * @return {String} possible object is {@link String}
	 */
	getContext() {
		return this.context;
	}

	/**
	 * Sets the value of the context property.
	 * @param {String} value allowed object is {@link String}
	 */
	setContext(value) {
		var oldValue = this.context;
		this.context = value;
		this._setAndNotify(90, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TextResource.Item}
	 */
	getItem() {
		if (!this.item) {
			this.item = [];
		}
		return this.item;
	}

	/**
	 * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Item</code> elements, or <code>null</code> if not set
	 */
	basicGetItem() {
		return this.item;
	}

	/**
	 * Creates a new instance of <code>TextResource</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> TextResource</code> object from.
	 * @return {TextResource} an object of type <code>TextResource</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createTextResource();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addItemAt(position, item) {
		this._addAtAndNotify(this.getItem(), position, item, 11, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addItem(item) {
		this.addItemAt(this.getItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeItemAt(position) {
		this._removeAtAndNotify(this.getItem(), position, 11, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeItem(item) {
		var i = this.getItem().indexOf(item);
		if (i >= 0) {
			this.removeItemAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "TextResource";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 89, "resourceLanguage", null));
		featureList.push(this.createFeature(false, false, false, 90, "context", null));
		var clazz;
		if (factory) {
			clazz = factory.createTextResourceItem().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 11, "item", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 89:
			this.setResourceLanguage((value));
			break;
		case 90:
			this.setContext((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 11:
			this.item = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 89:
			return this.getResourceLanguage();
		case 90:
			return this.getContext();
		case 11:
			return this.getItem();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 89:
			return this.getResourceLanguage();
		case 90:
			return this.getContext();
		case 11:
			return this.basicGetItem();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 11:
			this.addItemAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 11:
			this.addItem((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 11:
			this.removeItemAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 11:
			this.removeItem((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="text" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
TextResource.Item = class extends MoserObject{

	identifier = null;

	text = null;



	/**
	 * Gets the value of the identifier property.
	 * @return {String} possible object is {@link String}
	 */
	getIdentifier() {
		return this.identifier;
	}

	/**
	 * Sets the value of the identifier property.
	 * @param {String} value allowed object is {@link String}
	 */
	setIdentifier(value) {
		var oldValue = this.identifier;
		this.identifier = value;
		this._setAndNotify(91, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the text property.
	 * @return {String} possible object is {@link String}
	 */
	getText() {
		return this.text;
	}

	/**
	 * Sets the value of the text property.
	 * @param {String} value allowed object is {@link String}
	 */
	setText(value) {
		var oldValue = this.text;
		this.text = value;
		this._setAndNotify(275, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>Item</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Item</code> object from.
	 * @return {Item} an object of type <code>Item</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createTextResourceItem();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Item";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 91, "identifier", null));
		featureList.push(this.createFeature(false, false, false, 275, "text", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 91:
			this.setIdentifier((value));
			break;
		case 275:
			this.setText((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 91:
			return this.getIdentifier();
		case 275:
			return this.getText();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 91:
			return this.getIdentifier();
		case 275:
			return this.getText();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/TextResource.js